import React from 'react'; 
import ReactDOM from 'react-dom/client';





export function load_comment_post(id,I_comment,people) {

var mains = document.createElement("DIV");
mains.id = "container_app_2";
mains.style.animation = "fadein 0.5s ease-in";
//contoh
var id = id.concat("_C");

var x = document.getElementById(id).querySelectorAll("#container_app_2");

//The purpose is simple, so that adding the comment would be much more different and not too much of you know adding differently..7/6/2021
if(x.length < 2){
document.getElementById(id).appendChild(mains);

}else{
  //document.getElementById(id).appendChild(mains);
  
var y = document.getElementById(id).lastChild;
var z = y.lastChild;

if (z.id == "container_app_2") {
 // var x = document.getElementById(id).lastChild;
document.getElementById(id).insertBefore(mains,y);
}else{
document.getElementById(id).appendChild(mains);
}

}


var name = people.replaceAll("_"," ");

var P_recursive = React.createClass({
  
  displayName: "Hour",

  getDefaultProps: function getDefaultProps() {
    return {
      time: 42
    };
  },

  render: function render() {
    return React.createElement(
          Comment,
          { name: name, time: 3,url: "url(./profile/assets/php/"+people+"_front.png)"},
          I_comment
        );
  }
});

var container = React.createElement(
  "div",
  null,
  React.createElement(P_recursive, null)
  )
  const roots = ReactDOM.createRoot(document.getElementById("container_app_2"));
roots.render(container);

}

